/* eslint-disable no-unused-vars */
//@ts-ignore
export const elearningStore = store => {
    store.commit('INITIALIZE_STORE')
}